import { Component } from '@angular/core';

@Component({
  selector: 'app-table-skeleton',
  standalone: true,
  templateUrl: './table-skeleton.component.html',
  styleUrl: './table-skeleton.component.scss'
})
export class TableSkeletonComponent {
  readonly numberOfRows = new Array(20);
  readonly numberOfCols = new Array(5);
}
